import { toast } from 'react-toastify';

export const handleLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("id");
  toast.error("Session expired. Please log in again.");
  window.location.href = "/";
};
